import React, {useMemo} from "react";
import {ReactComponent as RemoveIcon} from "../../../../../../../../../assets/images/remove.svg";
import {Link} from "react-router-dom";
import {routeFunctions} from "../../../../../../../../../core/models/static/routes/app-routes";
import IconButton from "../../../../../../../../components/base/button/icon_button";

const CompareViewProductNotes = ({
                                     product,
                                     removeProduct,
                                 }) => {
    const productLink = useMemo(() => routeFunctions.lookup.single(product?.partNo), [product?.partNo]);

    /**
     * Handles removing a product from the list of items in compare screen:
     * - Shows a confirmation dialog from for user
     * - after confirmation, calls the function regarding this action
     *
     * @param {MouseEvent<HTMLButtonElement>} e
     */
    const getRemoveProductConfirmation = (e) => {
        e.stopPropagation()
        e.preventDefault()
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Do you want to remove the selected product from compare list?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (confirmed) => confirmed && _remove(),
        );
    }

    const _remove = (product) => {
        removeProduct(product).then();
    }

    return (
        <>
            <div className={'compare-product-notes'}>
                <div className={'compare-product-notes-header'}>
                    <Link to={productLink} className={'part-no mr-2'}>
                        {product?.partNo ?? ''}
                    </Link>
                    {
                        (removeProduct && !!product) &&
                        <IconButton
                            onPressed={getRemoveProductConfirmation}
                            color={'paper.error'}
                        >
                            <RemoveIcon/>
                        </IconButton>
                    }
                </div>
                <div className={'notes-container'}>
                    {
                        product?.notes?.map(note => (
                            <div key={`${note.title}-${note.message}`} className={'note'}>
                                <p>{note.title}</p>
                                <div dangerouslySetInnerHTML={{__html: note.msg}}/>
                            </div>
                        )) ?? <div className={'note not-available'}>
                            <p>There are no notes available</p>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default CompareViewProductNotes;
